/**
 * @description Gestion du bouton toggle
 */

/* global polyfillsIE */

(() => {
	// VARS
	const btnToggle = document.querySelectorAll('[data-js-btn-toggle-all]');

	// FONCTIONS
	// Gestion de la classe active
	const toggle = () => {
		btnToggle.forEach(function (btn) {
			btn.addEventListener('click', () => {
				btn.classList.toggle('active');
			});
		});
	};

	// GO 🚀
	const init = () => {
		document.addEventListener('DOMContentLoaded', () => {
			polyfillsIE();
			toggle();
		});
	};

	init();
})();
